import { Component, OnInit, OnDestroy } from '@angular/core';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Ticket } from 'src/app/models/ticket-models/ticket.model';

@Component({
  selector: 'app-tickets-ticket-dashboard',
  templateUrl: './tickets-ticket-dashboard.component.html',
  styleUrls: ['./tickets-ticket-dashboard.component.scss']
})
export class TicketsTicketDashboardComponent implements OnInit, OnDestroy {

  ticket: Ticket;
  refreshTicketSubscription: Subscription;
  getTicketInfoSubscription: Subscription;

  constructor(private ticketsService: TicketsService,
              private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getTicketInfo();
    this.refreshTicketSubscription = this.ticketsService.refreshTicketListen().subscribe(
      (res) => {
        this.getTicketInfo();
      }
    );
  }

  public getTicketInfo() {
    const internalId = this.activatedRoute.snapshot.params['ticketid'];
    this.getTicketInfoSubscription = this.ticketsService.getTicketInfo(internalId).subscribe(
      (res) => {
        this.ticket = res;
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-receipt', 'tickets-page.ticket detail', '/account/tickets', [new BRoute('account-page.account', '/account'), new BRoute('tickets-page.tickets', '/account/tickets'), new BRoute('tickets-page.ticket detail')]));
  }

  ngOnDestroy() {
    if (this.refreshTicketSubscription) { this.refreshTicketSubscription.unsubscribe(); }
    if (this.getTicketInfoSubscription) { this.getTicketInfoSubscription.unsubscribe(); }
  }
}
